import { withStyles } from '@material-ui/core';

import PriorityControl from './component';
import styles from './styles';

export default withStyles(styles)(PriorityControl);
